
import { ASSET_TYPE_METADATA } from './asset-type.metadata';
import { AssetType } from './asset-type.model';
import { GenericEntityDecorator } from '@scisys-uim/uim-common';


export abstract class AssetTypeEntityDecoratorBase extends GenericEntityDecorator<AssetType, number> {
  constructor() {
    super(ASSET_TYPE_METADATA, {
    }, {
    });
  }
  toKeyObjectFromRouteParams(params: any): number {
    if (params == null || params.assetTypeId == null) {
      return null;
    }
    return parseInt(params.assetTypeId);
  }
  toKeyUrlPathSegments(key: number): string {
    if (key == null) {
      return null;
    }
    return '' + key;
  }
  toKeyRouteSegments(item: AssetType): any[] {
    const key: number = this.metadata?.toKeyObject(item);
    if (key == null) {
      return null;
    }
    return [key];
  }
}




